import React, { useEffect } from 'react';
import { Modal, Input, Select, notification } from 'antd';
import { post, get } from '../../utils/http'
import api from '../../utils/api'

const { Option } = Select;
const { confirm } = Modal;

export default function CreateNewMenu(props) {

    const [menuname, setMenuname] = React.useState('');
    const [path, setPath] = React.useState('');
    const [component, setComponent] = React.useState('');
    const [permission, setPermission] = React.useState([]);
    const [menuIcon, setMenuIcon] = React.useState('');
    const [parentId, setParentId] = React.useState('');
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [isGetData, setIsGetData] = React.useState(false);
    const [parentList, setParentList] = React.useState([]);

    useEffect(() => {
        if (!isGetData) {

            post(api.queryParentList).then(function (response) {
                setParentList(response)
                setIsGetData(true);
            }).catch(function (error) {
                console.log("@getDataError", error)
                notification['error']({
                    message: 'Fail to get data, the modal will close.',
                });
                setTimeout(() => {
                    Modal.destroyAll();
                    props.closeCreateModal();
                }, 1500)
            })
        }
    }, [])


    const handleSubmit = () => {//submit button

        setConfirmLoading(true)
        var ps = permission.join(",")
        const createData = {
            menuName: menuname,
            menuPath: path,
            component: component,
            controlPermission: ps,
            menuIcon: menuIcon,
            parentId: parentId,
        }
        post(api.saveAndUpdateMenu, createData).then(function (response) {
            notification['success']({
                message: 'Create successfully.',
            });
            props.closeCreateModal()
            props.handleSearch()
            setConfirmLoading(false)
        }).catch(function (error) {
            notification['error']({
                message: 'Fail to create.',
            });
            console.log(error)
            setConfirmLoading(false)
        })
        props.closeCreateModal()
    }

    const handleCancle = () => {
        confirm({
            content: "Are you sure to close this modal?",
            onOk() {
                Modal.destroyAll();
                props.closeCreateModal();
            }
        });
    };

    return (
        <>
        
            <Modal
                destroyOnClose={true}
                title="Create Menu"
                visible={props.isOpenCreate}
                onOk={handleSubmit}
                confirmLoading={confirmLoading}
                onCancel={handleCancle}
            >
                    <div style={{ display: "flex" }}>
                        <p style={{ width: "110px", lineHeight: "36px" }}>Menuname </p>
                        <Input placeholder="menu name" onChange={event => setMenuname(event.target.value)} style={{ height: "36px", width: "350px" }} />
                    </div>

                    <div style={{ display: "flex" }}>
                        <p style={{ width: "110px", lineHeight: "36px" }}>Path </p>
                        <Input placeholder="path" onChange={event => setPath(event.target.value)} style={{ height: "36px", width: "350px" }} />
                    </div>

                    <div style={{ display: "flex", height:'auto' }}>
                        <p style={{ width: "110px", lineHeight: "36px" }}>Component </p>
                        <Input placeholder="conponent" onChange={event => setComponent(event.target.value)} style={{ height: "36px", width: "350px" }} />
                    </div>

                    <div style={{ display: "flex" }}>
                        <p style={{ width: "110px", lineHeight: "36px" }}>Permissions </p>
                        <Select
                            mode="multiple"
                            placeholder="permissions"
                            allowClear={true}
                            onChange={value => setPermission(value)}
                            style={{ height: "36px", width: "350px" }}
                        >
                            <Option key={"EDIT_BTN"}  >EDIT_BTN</Option>
                            <Option key={"CREATE_BTN"}>CREATE_BTN</Option>
                            <Option key={"SEARCH_BTN"}>SEARCH_BTN</Option>
                            <Option key={"DELETE_BTN"}>DELETE_BTN</Option>
                        </Select>
                    </div>

                    <div style={{ display: "flex" }}>
                        <p style={{ width: "110px", lineHeight: "36px" }}>MenuIcon</p>
                        <Input placeholder="menu icon name" onChange={event => setMenuIcon(event.target.value)} style={{ height: "36px", width: "350px" }} />
                    </div>

                    <div style={{ display: "flex" }}>
                        <p style={{ width: "110px", lineHeight: "36px" }}>Perant </p>
                        <Select
                            placeholder="perant"
                            onChange={value => setParentId(value)}
                            style={{ height: "36px", width: "350px" }}
                        >
                            <Option key="" value=""></Option>
                            {parentList.map((p) => {
                                return <Option key={p.menuId} value={p.menuId}>{p.menuName}</Option>
                            })}
                        </Select>
                    </div>
            </Modal>

        </>
    );
}